import { render } from "./ModificaBancale.vue?vue&type=template&id=c2c8a06a&scoped=true"
import script from "./ModificaBancale.vue?vue&type=script&lang=js"
export * from "./ModificaBancale.vue?vue&type=script&lang=js"

import "./ModificaBancale.vue?vue&type=style&index=0&id=c2c8a06a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2c8a06a"]])

export default __exports__